import React from 'react';
import {ItemList, TableHeader} from './components';
import {HeaderOption} from './types';
import styles from './ItemTable.module.scss';

interface Props<T> {
  items: T[];
  headers?: HeaderOption[];
  ordered?: boolean;
  onSelect(item: T): void;
  itemValuePicker(item: T): any[];
}

export function ItemTable<T>({
  items,
  headers,
  ordered,
  onSelect,
  itemValuePicker,
}: Props<T>) {
  const headerMarkup = headers ? <TableHeader headers={headers} /> : null;

  function renderItem(item: T) {
    const values = itemValuePicker(item);
    return values.map((value) => {
      return <td className={styles.Td}>{value}</td>;
    });
  }

  return (
    <table className={styles.Table}>
      {headerMarkup}
      <ItemList<T>
        ordered={ordered}
        items={items}
        renderItem={renderItem}
        onSelect={onSelect}
      />
    </table>
  );
}
